/*
 * @Description: 合同管理相关接口
 * @Author: huzhibo
 * @Email: hzbfun@gmail.com
 * @Date: 2020/11/17 11:09
 */
import http from "e6-base-core/axios/config";
import { e6ModuleSettleAccountsCenterApi } from "@/config/api";
const {
  host = "",
  E6_MS_TMS_FINANCIAL_WEB = ""
} = e6ModuleSettleAccountsCenterApi;

// 获取新增的合同初始化信息
export function getInitContractInfo() {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/contractInfo/init`,
    method: "post"
  });
}

// 保存合同信息
export function saveContractInfo(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/contractInfo/saveOrUpdate`,
    method: "post",
    data
  });
}

// 查询列表数据
export function getContractTableData(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/contractInfo/queryPage`,
    method: "post",
    data
  });
}

// 查询列表数据
export function getContractHistoryData(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/contractInfo/queryPageHistory`,
    method: "post",
    data
  });
}

// 导出
export function exportContractInfo(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/contractInfo/export`,
    method: "post",
    data
  });
}

// 删除
export function deleteContracts(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/contractInfo/deleteContracts`,
    method: "post",
    data
  });
}

// 根据id查询合同信息
export function fetchContractInfoById(params) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/contractInfo/findContractInfoById`,
    method: "get",
    params
  });
}

// 查询附件列表
export function getContractAttachment(params) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/contractInfo/getAttachment`,
    method: "get",
    params
  });
}

// 合同名称唯一性校验
export function contractCheckName(params) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/contractInfo/checkName`,
    method: "get",
    params
  });
}

// 合同编码唯一性校验
export function contractCheckCode(params) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/contractInfo/checkCode`,
    method: "get",
    params
  });
}

// 终止合同
export function fetchContractClose(params) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/contractInfo/close`,
    method: "get",
    params
  });
}
